/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of the rail transport. Allowed values are 
 *   `RIT` - Rail and Cruise
 *   `RNF` - Rail and Fly
 * 
 * @export
 */
export const RailTransportType = {
    RIT: 'RIT',
    RNF: 'RNF'
} as const;
export type RailTransportType = typeof RailTransportType[keyof typeof RailTransportType];


export function instanceOfRailTransportType(value: any): boolean {
    for (const key in RailTransportType) {
        if (Object.prototype.hasOwnProperty.call(RailTransportType, key)) {
            if (RailTransportType[key as keyof typeof RailTransportType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RailTransportTypeFromJSON(json: any): RailTransportType {
    return RailTransportTypeFromJSONTyped(json, false);
}

export function RailTransportTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RailTransportType {
    return json as RailTransportType;
}

export function RailTransportTypeToJSON(value?: RailTransportType | null): any {
    return value as any;
}

export function RailTransportTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RailTransportType {
    return value as RailTransportType;
}

